"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _Location = _interopRequireDefault(require("../../molecules/Location"));
var _Call = _interopRequireDefault(require("../../molecules/Call"));
var _HoursOfOperation = _interopRequireDefault(require("../../molecules/HoursOfOperation"));
var _OnlineOrderingNavigationHeader = _interopRequireDefault(require("./components/OnlineOrderingNavigationHeader"));
require("./OnlineOrderingNavigation.css");
function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var OnlineOrderingNavigation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(OnlineOrderingNavigation, _React$Component);
  var _super = _createSuper(OnlineOrderingNavigation);
  function OnlineOrderingNavigation(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, OnlineOrderingNavigation);
    _this = _super.call(this, props);
    _this.state = {
      height: null
    };
    _this.handleScroll = _this.handleScroll.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(OnlineOrderingNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var parentId = this.props.parentId;
      if (typeof document !== "undefined") {
        var container = document.getElementById(parentId);
        container.addEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var parentId = this.props.parentId;
      if (typeof document !== "undefined") {
        var container = document.getElementById(parentId);
        container.removeEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(event) {
      var _this$props = this.props,
        minHeight = _this$props.minHeight,
        initialHeight = _this$props.initialHeight,
        parentId = _this$props.parentId;
      if (typeof document !== "undefined") {
        var container = document.getElementById(parentId);
        var scrollTop = container.scrollTop;
        var height = Math.max(minHeight, initialHeight - scrollTop);
        this.setState({
          height: height
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        businessName = _this$props2.businessName,
        logo = _this$props2.logo,
        phoneNumber = _this$props2.phoneNumber,
        address = _this$props2.address,
        hours = _this$props2.hours,
        initialHeight = _this$props2.initialHeight,
        minHeight = _this$props2.minHeight;
      var height = this.state.height;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "online-ordering-navigation",
        style: {
          height: height || initialHeight
        }
      }, /*#__PURE__*/_react["default"].createElement(_OnlineOrderingNavigationHeader["default"], {
        businessName: businessName,
        logo: logo,
        atBaseHeight: height === minHeight
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "contact-info desktop"
      }, /*#__PURE__*/_react["default"].createElement(_Location["default"], {
        address: address,
        inline: true,
        showIcon: true
      }), /*#__PURE__*/_react["default"].createElement(_Call["default"], {
        phoneNumber: phoneNumber,
        showIcon: true
      }), /*#__PURE__*/_react["default"].createElement(_HoursOfOperation["default"], {
        hours: hours,
        displayOption: "modal"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "contact-info mobile"
      }, /*#__PURE__*/_react["default"].createElement(_Location["default"], {
        address: address,
        inline: true,
        showIcon: true,
        as: "icon"
      }), /*#__PURE__*/_react["default"].createElement(_Call["default"], {
        phoneNumber: phoneNumber,
        showIcon: true,
        as: "icon"
      }), /*#__PURE__*/_react["default"].createElement(_HoursOfOperation["default"], {
        as: "icon",
        hours: hours,
        displayOption: "modal",
        iconAs: "button"
      })));
    }
  }]);
  return OnlineOrderingNavigation;
}(_react["default"].Component);
exports["default"] = OnlineOrderingNavigation;
;
OnlineOrderingNavigation.propTypes = {
  businessName: _propTypes["default"].string.isRequired,
  phoneNumber: _propTypes["default"].string.isRequired,
  address: _propTypes["default"].object.isRequired,
  hours: _propTypes["default"].array.isRequired,
  parentId: _propTypes["default"].string.isRequired,
  logo: _propTypes["default"].string,
  initialHeight: _propTypes["default"].number,
  minHeight: _propTypes["default"].number
};
OnlineOrderingNavigation.defaultProps = {
  logo: '',
  initialHeight: 100,
  minHeight: 70
};